export const CONSENT_COOKIE = 'cookie_consents';
